import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Company 
export const getCompany = createAsyncThunk("company/get-companies ", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-companies`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Companies - ', error);
        throw error;
    }
})



export const getCompaniesSites = async (id) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-related-companies-list/${id}`, {
        headers: {
          "auth-token": token,
        }
      },)
      // console.log("<<<<<<???????????????????response",response)
      return response;
    } catch (error) {
      throw error
    }
  }

